import { MatDialog } from '@angular/material/dialog';
import * as aspSettings from '@core_n/asp/aspSettings';
import { userSettings } from '@core_n/common/settings';
import { extractSensorAcousticName } from '@core_n/common/utils';
import { SensorObject } from 'src/app/asp/SensorObject';
import { AroAngTrackService } from '../../../app/aro/aro-angularTrack.service';
import * as projConsts from '../../../app/common/projConsts';
import { AppConfig } from '../app.config';
import * as consts from '../common/consts';
import { AppInjector } from '../common/inject';
import { aspMngr } from './../asp/AspMngr';
import { AcousticVector, AcousticVectorObject } from './AcousticVectorObject';
import { AspObject, ObjectType } from './AspObject';
import { IAcousticVectorPool, IMapMngr, IObjectsPool } from './interfaces';
import { ObjectsPool } from './ObjectsPool';
import { SensorCoreObject } from './SensorCoreObject';
import { SensorsCorePool } from './SensorsCorePool';

export class AcousticVectorPool extends ObjectsPool implements IAcousticVectorPool {
  private static _self: AcousticVectorPool = null;

  public static getSelf(): AcousticVectorPool {
    if (this._self == null)
      this._self = new AcousticVectorPool();
    return this._self;
  }

  private constructor() {
    super(ObjectType.AcousticVector, consts.MSG_TYPE_SNS_VECTOR, undefined, false, true /* clickable */, false);
  }

  contextMenuActions(obj: AspObject): number[] {
    let vec = obj as AcousticVectorObject;
    return [projConsts.USER_ACTION_SHOW_ARO, vec.HistoryOn ? consts.USER_ACTION_DISABLE_VECTOR_HISTORY : consts.USER_ACTION_ENABLE_VECTOR_HISTORY];
  }

  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr, dialog?: MatDialog): boolean {
    let vec = obj as AcousticVectorObject;
    if (action == projConsts.USER_ACTION_SHOW_ARO) {
      AppInjector.get(AroAngTrackService).showAngTrack(vec);
      return true;
    }

    if (action == consts.USER_ACTION_ENABLE_VECTOR_HISTORY) {
      vec.HistoryOn = true;
      if (aspSettings.acousticHistSnsId != 0) {
        vec.HistoryOn = false;
        vec.HistoryDeleted = false;
      }
      aspSettings.setAcousticHistSnsId(vec.Data.SnsID);
      vec.notifyDataChange();
      return true;
    }

    if (action == consts.USER_ACTION_DISABLE_VECTOR_HISTORY) {
      vec.HistoryOn = false;
      vec.HistoryDeleted = false;
      aspSettings.setAcousticHistSnsId(0);
      vec.notifyDataChange();
      return true;
    }
    return false;
  }

  confirmAndDeleteAllObjects() {
    this.deleteAllObjects();
  }

  periodicUpdate(): boolean {
    let objsToDelete = [];
    this.allObjects.forEach((obj: AspObject) => {
      if (!obj.isValid())
        objsToDelete.push(obj);
    });
    objsToDelete.forEach((obj: AspObject) => {
      this.deleteObject(obj);
    });
    return true;
  }

  handleMsg(msgObj: any): void {
    if (this.isAcousticVectorFiltered(msgObj)){
      return;
    }
    // let source = enums.sourceStr2Num(msgObj.Source);
    // if (source == enums.Source.solocate && !userSettings.canSeeSolo)
    //   return;

    // if (source == enums.Source.aman && !userSettings.canSeeAi)
    //   return;

    if (AppConfig.settings.ShowLogs)
      console.log("[AcousticVectorPool] handleMsg, Acoustic Vector msg:", msgObj);

    if (msgObj.IsDelete) {
      let vecObj = this.getObject(msgObj.TrackUUID) as AcousticVectorObject;
      if (vecObj) {
        this.deleteObject(vecObj);
      }
      return;
    }

    let snsObject;
    // if (msgObj.sic)
    //   snsObject = aspObjects.sensorsPool.getSensorBySicSac(msgObj.Sic, 0) as unknown;
    // else 
    msgObj.sensorName = extractSensorAcousticName(msgObj.targetId)
    var sensorsPool = aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool;
    snsObject = sensorsPool.getSensorByName(msgObj.sensorName) as SensorCoreObject;
    if (!snsObject) {
       return; 
    }

    let vec: AcousticVector = new AcousticVector;
    vec.handleMsg(msgObj, snsObject as SensorCoreObject);
    let vecObj: AcousticVectorObject = null;
    vecObj = this.getObject(AspObject.generateId(ObjectType.AcousticVector, snsObject.sensorID)) as AcousticVectorObject;
    if (!vecObj) {
      vecObj = this.createAcousticVectorObject(this, ObjectType.AcousticVector, Number.parseInt(snsObject.sensorID), snsObject as SensorObject);
      vecObj.handleMsg(vec);
      this.addObject(vecObj);
    }
    else
      vecObj.handleMsg(vec);

  }

  private isAcousticVectorFiltered(msgObj: any) {
    let isFiltered = false;
    if (this.isVectorTypeFiltered(msgObj.CLS)){
      isFiltered = true;
    }
    if (!userSettings.canSeeAi && !userSettings.canSeeSolo){
      isFiltered = true;
    }
    
    return isFiltered;
  }

  private isVectorTypeFiltered(CLS: string): boolean {
    const unknownType = !Object.keys(userSettings.acousticVectorTypesOn).find(key => key == CLS);
    const allowUnknown = userSettings.acousticVectorTypesOn["unknown"];
    return  (unknownType && !allowUnknown) || !userSettings.acousticVectorTypesOn[CLS];
  }
  
  protected createAcousticVectorObject(objectsPool: IObjectsPool, objectType: ObjectType, id: number, sns: SensorObject): AcousticVectorObject {
    return new AcousticVectorObject(objectsPool, objectType, id, sns);
  }
}